import { useEffect } from "react";
import { useCardFunc } from "../hooks";

import { SimpleGrid, VisuallyHidden } from "@chakra-ui/react";

import { Nav } from "../components/Nav";
import { Card } from "../components/Cards/Card";

import {Adsense} from '@ctrl/react-adsense';

// import { backsuDrop } from "./style";

export const Home = () => {
  let defaultCards = [
    { id: 0, num: 1, cardName: "Primary", cardValue: "Nunito" },
    { id: 1, num: 2, cardName: "Secondary", cardValue: "Roboto" },
  ];

  const {
    card,
    setCard,
    addCard,
    deleteCard,
    handleNameChange,
    handleOptionChange,
  } = useCardFunc(defaultCards, {
    cardName: "Text",
    cardValue: "Nunito",
  });

  let n = card.length;

  // Saving State Logic
  useEffect(() => {
    let data = localStorage.getItem("FontFamilies");
    if (data) {
      setCard(JSON.parse(data));
    }
  }, [setCard]);

  useEffect(() => {
    localStorage.setItem("FontFamilies", JSON.stringify(card));
  });

  return (
    <>
      <Nav title="Choose Fonts" home />

      <VisuallyHidden>
        Felco Themegen is a Design System Creator and Style Guide. That helps
        developers and designers to create visual typography style guide and
        color theme palette for their Brands Design and Personal Projects and
        export them as js, json.
      </VisuallyHidden>
      <Adsense
        client="ca-pub-6991856412998100"
        slot="1182937771" 
      />

      {/* <backsuDrop /> */}
      <SimpleGrid
        columns={{ md: 2, lg: 3 }}
        spacingX="20px"
        spacingY="28px"
        mb="32px"
      >
        {card.map((val) => {
          return (
            <Card
              id={val.id}
              num={val.num}
              deleteCard={() => deleteCard(val.id)}
              name={val.cardName}
              cardValue={val.cardValue}
              handleNameChange={handleNameChange}
              handleOptionChange={handleOptionChange}
            />
          );
        })}
        {card[n - 1].num === 9 ? "" : <Card create addCard={addCard} />}
      </SimpleGrid>
    </>
  );
};
